import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SettingsService } from '../../../core/settings/settings.service';
import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  imports: [RouterLink, IconComponent],
})
export class TopNavbarComponent {
  private settingsService = inject(SettingsService);

  public readonly title = input<string>(undefined!);
  public readonly backLink = input<string | string[] | undefined>(undefined);

  public settings = this.settingsService.settings;
}
